module.exports = __webpack_public_path__ + "static/media/resourceVideo.16c79dd2.svg";